import React from 'react';
import './styles.css';

interface Props {
  width: number;
  children: React.ReactElement[] | React.ReactElement;
  showGuidelines?: boolean;
}

export const BASELINE_SVG_CANVAS_WIDTH = 500;

const EditorSvgCanvas = React.memo(
  ({width, children, showGuidelines}: Props) => {
    const getScaleFactor = () => {
      const scale = (width * 100) / BASELINE_SVG_CANVAS_WIDTH;
      return scale / 100;
    };

    return (
      <div style={{width, height: width / 1.77}} className="EditorSvgCanvas">
        <svg
          width={BASELINE_SVG_CANVAS_WIDTH}
          height={BASELINE_SVG_CANVAS_WIDTH / 1.77}
          transform={`scale(${getScaleFactor()})`}>
          {children}
          {showGuidelines && (
            <g>
              <line
                x1={0}
                y1={BASELINE_SVG_CANVAS_WIDTH / 1.77 / 2}
                x2={BASELINE_SVG_CANVAS_WIDTH}
                y2={BASELINE_SVG_CANVAS_WIDTH / 1.77 / 2}
                stroke="white"
                strokeDasharray="2 2"
              />
              <line
                x1={BASELINE_SVG_CANVAS_WIDTH / 2}
                y1={0}
                x2={BASELINE_SVG_CANVAS_WIDTH / 2}
                y2={BASELINE_SVG_CANVAS_WIDTH / 1.77}
                stroke="white"
                strokeDasharray="2 2"
              />
            </g>
          )}
        </svg>
      </div>
    );
  },
);

export default EditorSvgCanvas;
